// app/windows/AProposContent.tsx
export function AProposContent() {
  return (
    <>
    <p className=" mt-1 font-stretch-condensed font-bold ">
      C&apos;EST QUOI OCTOBOTS?
    </p>
      <p className="mt-3 text-justify font-stretch-condensed">
        L&apos;événement Octobots est une compétition de robotique organisé à
        l&apos;UQAC par le club de robotique (CRUQAC) destinée aux étudiantes et étudiants de l&apos;université et 
        ceux venus d&apos;ailleurs afin de s&apos;affronter dans une série de combats suivant des règles bien définies et un 
        schema de tournoi precis.Elle vise à promouvoir l&apos;apprentissage de la
        robotique, de la programmation et du travail d&apos;équipe dans un cadre 
        ambiant et stimulant.
      </p>
      <p className=" mt-6  font-stretch-condensed font-bold ">
        NOS PARTENAIRES ET COMMANDITAIRES:
        <ul className="mt-2 list-disc list-inside font-normal font-stretch-condensed">
          <li className="opacity-80">Partenaire 1</li>
          <li className="opacity-80">Partenaire 2</li>
          <li className="opacity-80">Partenaire 3</li>
        </ul>
      </p>
    </>
  );
}
